<template>
<div>
   <navbar></navbar>
  <div class="container margintop">
    <div class="columns has-text-left ">
      <div class="column">
        <div class="title" :class="$i18n.locale">
          <p style="color:white;">{{$t('landingPage.easyWay')}}</p>
          <p style="color:white"> {{$t('landingPage.startingAndScaling')}}</p>
        </div>
        <div class="text-container">
          <div><p style="color:white" :class="$i18n.locale"> {{ $t('landingPage.excellent')}}</p>
            <div>
              <div class="columns marginbutton">
                <div class="column is-6 has-text-centered-mobile" >
                  <b-button @click="gopath('profile')"  class="blurbutton" style="width: 80%;">
                    <p :class="$i18n.locale">{{$t('browseMentors')}}</p> 
                  </b-button>
                </div>
                <div class="column is-6 has-text-centered-mobile">
                    <b-button  @click="gopath('signup/company')"  class="blurbutton" style="width: 80%;">
                      <p :class="$i18n.locale">{{$t('signUpCompany')}}</p>
                    </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column">

      </div>
    </div> 
    <div class="columns margin-key" id="keyfeatures">
      <div class="column" >
        <h2 class="is-size-1 has-text-white has-text-weight-bold" :class="$i18n.locale">{{$t('nav.keyFeatures')}}</h2>
      </div>
    </div>
     <div class="columns " >
      <div class="column is-4 mg-b-5" >
        <div class="border-circle ">
          <img src="@/assets/1.png">
        </div>
        <div class="has-text-centered has-text-white">
          <h3 class="is-size-3 has-text-weight-bold color-sky-blue">MENTOR PROFILE</h3>
          <h4 class="is-size-4" :class="$i18n.locale">{{$t('landingPage.mentorProfile.greatMentor')}}</h4>
          <p class="is-size-5" :class="$i18n.locale">{{$t('landingPage.mentorProfile.sharing')}}
          {{$t('landingPage.mentorProfile.professional')}}
          {{$t('landingPage.mentorProfile.never')}}</p>
        </div>
      </div>
      <div class="column is-4 mg-b-5" >
        <div class="border-circle ">
         <img src="@/assets/2.png">
        </div>
        <div  class="has-text-centered  has-text-white">
           <h3 class="is-size-3 has-text-weight-bold color-sky-blue">TICKET</h3>
           <h4 class="is-size-4" :class="$i18n.locale">{{$t('landingPage.ticket.greatSolution')}}</h4>
           <p class="is-size-5" :class="$i18n.locale">{{$t('landingPage.ticket.accessing')}}<br>
            {{$t('landingPage.ticket.mentoring')}}
            </p>
        </div>
      </div>
      <div class="column is-4 mg-b-5" >
        <div class="border-circle ">
          <img src="@/assets/3.png">
        </div>
        <div  class="has-text-centered has-text-white">
           <h3 class="is-size-3 has-text-weight-bold color-sky-blue">REVIEW</h3>
           <h4 class="is-size-4" :class="$i18n.locale">{{$t('landingPage.review.confidential')}}</h4>
           <p class="is-size-5" :class="$i18n.locale">{{$t('landingPage.review.knowing')}}<br>
            {{$t('landingPage.review.infinite')}}<br>
            {{$t('landingPage.review.together')}}</p>
        </div>
      </div>

    </div>
    <div class="footer2"> <i class="far fa-copyright"></i>&nbsp;<span class="has-text-weight-semibold">Great</span><span style="font-weight: initial !important;">Growth</span>. All Rights Reserved</div>
  </div>
</div>

</template>

<script>
import navbar from './Indexnavbar'
export default {
    components:{
      navbar,

    },
    data() {
      return {

      }
    },
    methods: {
      gopath(val) {
        this.$router.push(val);
      },
    },
    mounted() {
      // this.$i18n.locale = 'en'
    },
      computed:{
    },
};
</script>
<style scoped>
html{
  scroll-behavior: smooth;
}
.margin-key{
  margin-top: 415px;
}
.border-circle{
  width: 250px;
  height: 250px;
  border:4px solid #fff;
  border-radius: 50%;
  margin:0 auto 15px auto;
  overflow: hidden;

}
.footer2{
  padding: 8px 0;
    color: white !important;
    white-space: nowrap;
    text-align: center;
}
.marginbutton{
    margin-top: 20px;
}
.blurbutton{
    height: auto;
    padding: 10px 20%;
    z-index: 1;
    background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
    border-radius: 40px;
    font-weight: bold;
    border:1px;
    border-style: solid;
    border-color: transparent;
    transition: all 0.3s;
    --webkit-transition: all 0.3s;
    color: #fff;
}
.blurbutton:hover{
    height: auto;
    padding: 10px 20%;
    z-index: 38;
    color:white!important;
    background: transparent!important;
    border-radius: 40px;
    font-weight: bold;
    border:1px;
    border-style: solid;
    border-color: white!important;
}
.margintop{
    margin-top: 9vw;
}
.title{
     line-height: 1.5;
}
.text-container{
    line-height: 1.7;
    font-size: 1.3rem;
    color: white;
    font-weight: inherit;
}
@media screen and (min-width: 100px) and (max-width: 767px) {
  .title{
    font-size:20px;
  }
  .marginbutton{
    margin-top: 50px;
  }
  .margin-key{
    margin-top: 105px;
  }
  .text-container{
    font-size:18px;
  }
  .container{
    margin:0 15px;
  }
  .margintop{
    margin-top: 60px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px){
  .container{
    margin-left:15px;
    margin-right:15px;
  }
}

</style>